
<!-- <div class="col-12" *ngIf="isLoading">
  <app-busy></app-busy>
</div> -->

<div class="container-fluid">

  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h4><span style="padding-right:10px"></span> <i class="fa fa-edit"></i><span id="procesHeader">{{processHeader}}</span>Compliance Certificate for <b><span id="carrierName">{{carrierNameNew}}</span></b>.<ng-container> Permit: {{permitCode}} - {{permitNumber}}</ng-container>
    </h4></div>
    </div>
  <hr>
  <div class="container-fluid">

    <hr />
    <div class="row" style="margin:0px;padding:0px;">
      <div class="col-12" style="margin:0px;padding:0px;" *ngIf="!viewPage">
        <div class="prx-nav" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
          <ul class="nav nav-pills nav-tabs nav-fill" role="tablist" style="margin:0px;padding:0px;">
  
              <li class="nav-item tb-siz" (click)="onActive1(0)">
              <a class="nav-link text-left"  [ngClass]="{ 'active':utility.activeTab==0,'disabled':(utility.confirmCtrl==false)}">
                <span class="row">
                  <span  class="col-12 centrer tab-hd"><strong>1</strong> Compliance Details</span>
                </span>
              </a>
            </li>
  
            <li class="nav-item tb-siz" (click)="onActive1(1)">
              <a class="nav-link text-left"    [ngClass]="{ 'active':utility.activeTab==1,'disabled':(utility.confirmCtrl==false)}">
                <span class="row">
                  <span  class="col-12 centrer tab-hd"> <strong >2</strong> Uploads
               </span> </span>
              </a>
            </li>
            <li class="nav-item tb-siz" (click)="onActive1(2)" >
              <a class="nav-link"   [ngClass]="{ 'active':utility.activeTab==2,'disabled':(utility.confirmCtrl==false)}">
                <span class="row" >
                  <span  class="col-12 centrer tab-hd">  <strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">3</strong> Confirmation
                  </span> </span>
               
              </a>
          </li>
         
          </ul>
        </div>
      </div>
      <div class="col-12" style="margin:0px;padding:0px;">
        <div class="tab-content" style="margin-top:20px;width:100%;">
          <div class="tab-pane mk-frm" id="car-doc" *ngIf="utility.activeTab==0" [ngClass]="{ 'active':utility.activeTab==0}">
            <div class="row">
              <div class="col-12" style="margin-top:20px!important;" *ngIf="utility.activeTab==0">
                <app-compliance-details [dataCntrl]="dataCntrl"></app-compliance-details>
              </div>
            </div>
          </div>

          <div class="tab-pane mk-frm" id="car-conf" *ngIf="utility.activeTab==1" [ngClass]="{ 'active':utility.activeTab==1}">
            <div class="row" style="margin-top:20px!important;">
              <div class="col-12" >
                <app-app-uploads isAnnualCompliance='true' [dataCntrl]="dataCntrl"></app-app-uploads>
              </div>
            </div>
          </div>
          <div class="tab-pane mk-frm" id="car-conf" *ngIf="utility.activeTab==2" [ngClass]="{ 'active':utility.activeTab==2}">
            <div class="row" style="margin-top:20px!important;">
              <div class="col-12" *ngIf="utility.activeTab==2">
                <c-confirmation isAnnualCompliance='true' [dataCntrl]="dataCntrl"></c-confirmation>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

